import React from "react";
import { useTranslation } from "react-i18next";

import { NonEditableFormField } from "../../guests/components/form/FormFields";
import type { ReservationCustomQuestionAnswer } from "@/types/reservation";

interface CustomQuestionAnswersProps {
  answers: ReservationCustomQuestionAnswer[];
}

export const CustomQuestionAnswers: React.FC<CustomQuestionAnswersProps> = ({
  answers,
}) => {
  const { t } = useTranslation();

  const sortedAnswers = [...answers].sort((first, second) =>
    first.order === second.order
      ? first.question.localeCompare(second.question)
      : first.order - second.order,
  );

  return (
    <section className="mt-6" aria-labelledby="custom-question-answers-title">
      <h3
        id="custom-question-answers-title"
        className="text-violet mb-4 text-sm"
      >
        {t("reservation.profile.customQuestions")}
      </h3>

      {sortedAnswers.length > 0 ? (
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {sortedAnswers.map((item) => (
            <NonEditableFormField
              key={item.id}
              value={item.answer || "—"}
              isCopy={false}
              label={item.question}
              labelClassName="text-foreground"
              contentClassName="mt-3 min-h-9 items-center rounded-lg border border-neutral-200 px-3 py-1 text-sm text-muted-foreground"
            />
          ))}
        </div>
      ) : (
        <p className="text-muted-foreground rounded-lg border border-neutral-200 px-3 py-2 text-sm">
          {t("reservation.profile.noCustomQuestionAnswers")}
        </p>
      )}
    </section>
  );
};
